import { render, staticRenderFns } from "./EditProgramType.vue?vue&type=template&id=11b5680e"
import script from "./EditProgramType.vue?vue&type=script&lang=js"
export * from "./EditProgramType.vue?vue&type=script&lang=js"
import style0 from "./EditProgramType.vue?vue&type=style&index=0&id=11b5680e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports